import { Plus, Trash2 } from 'lucide-react'
import { Button, Input, Textarea } from '@/components/ui'
import type { CorrectiveAction } from '../api/types'

interface Props {
  items: CorrectiveAction[]
  onChange: (items: CorrectiveAction[]) => void
  readOnly?: boolean
}

function blankRow(): CorrectiveAction {
  return { action: '', owner: '', due_date: '' }
}

export function CorrectiveActionsEditor({ items, onChange, readOnly = false }: Props) {
  const rows = items.length > 0 ? items : [blankRow()]

  function update(idx: number, field: keyof CorrectiveAction, value: string) {
    onChange(rows.map((row, i) => (i === idx ? { ...row, [field]: value } : row)))
  }

  function addRow() {
    onChange([...rows, blankRow()])
  }

  function removeRow(idx: number) {
    if (rows.length === 1) {
      onChange([blankRow()])
    } else {
      onChange(rows.filter((_, i) => i !== idx))
    }
  }

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-[2.4fr_1fr_1fr_36px] gap-2 px-1">
        {['Action', 'Owner', 'Due Date', ''].map((h) => (
          <span key={h} className="text-xs font-medium text-secondary uppercase tracking-wide">
            {h}
          </span>
        ))}
      </div>
      {rows.map((row, idx) => (
        <div key={idx} className="grid grid-cols-[2.4fr_1fr_1fr_36px] gap-2 items-start">
          <Textarea rows={2} value={row.action ?? ''} onChange={(e) => update(idx, 'action', e.target.value)} placeholder="Corrective / preventive action" disabled={readOnly} />
          <Input value={row.owner ?? ''} onChange={(e) => update(idx, 'owner', e.target.value)} placeholder="Owner" disabled={readOnly} />
          <Input value={row.due_date ?? ''} onChange={(e) => update(idx, 'due_date', e.target.value)} placeholder="e.g. Immediate" disabled={readOnly} />
          {!readOnly ? (
            <button
              type="button"
              onClick={() => removeRow(idx)}
              className="h-8 w-8 flex items-center justify-center rounded text-secondary hover:text-danger hover:bg-danger/10 transition-colors"
              title="Remove action"
            >
              <Trash2 size={14} />
            </button>
          ) : (
            <div />
          )}
        </div>
      ))}
      {!readOnly && (
        <Button variant="ghost" size="sm" onClick={addRow} className="mt-1">
          <Plus size={14} className="mr-1" /> Add action
        </Button>
      )}
    </div>
  )
}
